// @flow
import { colors } from 'bench-style-constants';
import React, { type Node } from 'react';
import styled from 'styled-components';

import TextBlock from './TextBlock';

const StyledSection = styled.section`
  ${({ background }) => background && `background: ${background}`};
  ${({ hasBorderBottom }) => hasBorderBottom && `border-bottom: 1px solid ${colors.silt}`};
  ${({ hasBorderTop }) => hasBorderTop && `border-top: 1px solid ${colors.silt}`};
  padding: ${({ padding }) => padding || '24px'};
`;

const SidebarSectionTitle = styled(TextBlock)`
  margin-bottom: 8px;
  padding: ${({ titlePadding }) => titlePadding || '0px'};
`;

type SidebarSectionProps = {
  background?: string,
  children?: Node,
  hasBorderBottom?: boolean,
  hasBorderTop?: boolean,
  title?: string,
  padding?: string,
  titlePadding?: string,
};

/**
 * Used for adding consistent spacing around sections within a Sidebar. Takes background and border
 * props to add visual contrast between adjacent sections.
 */
const SidebarSection = ({ children, title, ...props }: SidebarSectionProps) => (
  <StyledSection {...props}>
    {title && (
      <SidebarSectionTitle {...props} color={colors.cloud} styleType="small" uppercase>
        {title}
      </SidebarSectionTitle>
    )}
    {children}
  </StyledSection>
);

SidebarSection.defaultProps = {
  background: undefined,
  children: undefined,
  hasBorderBottom: false,
  hasBorderTop: false,
  title: undefined,
};

export default SidebarSection;
